export const SITE_URL = 'https://www.cigarera.cn'

export const DEFAULT_SEO = {
  title: '香港雪茄時代CigarEra：歐洲古巴行貨直供，專業雪茄海淘選購平台',
  description: '香港雪茄時代CIGARERA為一站式雪茄海淘平台，專售歐洲官方授權古巴行貨，價格親民。會員消費累積積分可兌換禮品、享专属獨家折扣；憑嚴謹品控與專業服務，滿足您的選購需求。'
}

function ensureMeta(name) {
  let tag = document.querySelector(`meta[name="${name}"]`)
  if (!tag) {
    tag = document.createElement('meta')
    tag.setAttribute('name', name)
    document.head.appendChild(tag)
  }
  return tag
}

function ensureCanonical() {
  let tag = document.querySelector('link[rel="canonical"]')
  if (!tag) {
    tag = document.createElement('link')
    tag.setAttribute('rel', 'canonical')
    document.head.appendChild(tag)
  }
  return tag
}

export function buildCanonical(path = '/') {
  if (path === '/') return `${SITE_URL}/`
  return `${SITE_URL}${path}`
}

export function stripHtml(html = '') {
  return html
    .replace(/<[^>]*>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
}

export function updateSeo({
  title = DEFAULT_SEO.title,
  description = DEFAULT_SEO.description,
  canonical = buildCanonical('/'),
  robots = 'index,follow'
} = {}) {
  document.title = title
  ensureMeta('description').setAttribute('content', description)
  ensureMeta('robots').setAttribute('content', robots)
  ensureCanonical().setAttribute('href', canonical)
}
